export const AllowedDomainsAndAttributeMappingSaml = '/admin-guide/configuring-the-saml-integration';

export const ReadArticleLink = '/admin-guide/managing-access#managing-service-level-roles';
